import Styled, { css } from 'styled-components';

import { media } from '../../../../../lib/StyledComponents';
import { ITransitionStates, VALID_TRANSITION_STATES } from '../../../Animations/Animations';
import { cssDeclaration } from '../../../Utils';

import { TRANSITION_DURATION } from './HeaderDrawer';

export enum VALID_PLACEMENTS {
  allChildren = ':not(:first-of-type)',
  lastChildOnly = ':last-of-type',
}

export const StyledDrawer = Styled.ul<ITransitionStates>`
  width: 100%;
  position: absolute;
  left: 0;
  overflow: hidden;

  ${({ theme: { themeTwo }, transitionState }) => {
    const { layout: { header }} = themeTwo;
    const { dropdown } = header;
    const borderOffset = typeof header.border === 'string' ?
     '0px' : themeTwo.global.edgeSize[header.border.size] || header.border.size;

    return css`
      z-index: ${themeTwo.global.zIndex.higher};
      transition: transform ${TRANSITION_DURATION}ms ease-in-out;
      transform-origin: top;
      transform: ${(() => {
        switch (transitionState) {
          case VALID_TRANSITION_STATES.entered:
            return 'scaleY(1)';
          case VALID_TRANSITION_STATES.entering:
            return 'scaleY(0)';
          case VALID_TRANSITION_STATES.exiting:
            return 'scaleY(0)';
          default:
            return 'scaleY(1)';
        }
      })()};

      top: calc(100% + ${borderOffset});
      /* background-color */ ${cssDeclaration(themeTwo, 'background-color', header.dropdown.backgroundColor)};
      /* box-shadow */ ${cssDeclaration(themeTwo, 'box-shadow', header.dropdown.shadow)};
      /* border */ ${header.dropdown.border && cssDeclaration(themeTwo, 'border', header.dropdown.border)};
      /* border-radius */ ${cssDeclaration(themeTwo, 'border-radius', header.dropdown.borderRadius)};
      /* width */ ${cssDeclaration(themeTwo, 'width', header.dropdown.width)};
      /* padding */ ${cssDeclaration(themeTwo, 'padding', header.dropdown.padding)};
      /* align-items */ ${cssDeclaration(themeTwo, 'align-items', header.dropdown.alignItems)};

      ${dropdown.link.divider && css`
        & > li${dropdown.link.divider.placement} {
          position: relative;

          &::before {
            content: "";
            display: block;
            margin: 0 auto;
            background-color: red;
            /* height */ ${cssDeclaration(themeTwo, 'height', dropdown.link.divider.height)};
            /* margin */ ${cssDeclaration(themeTwo, 'margin', dropdown.link.divider.margin)};
            /* background-color */ ${cssDeclaration(themeTwo, 'background-color', dropdown.link.divider.backgroundColor)};
            /* width */ ${cssDeclaration(themeTwo, 'width', dropdown.link.divider.width)};
          }
        }
      `}

      ${media.small`
        left: auto;
        right: 0;
      `}
    `;
  }}
`;
